import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

/* Scrolls sideways rather than wrapping, so a long list of tabs stays one row
   on a phone, as the design shows. */
export const tabList = css`
  display: flex;
  margin: 0;
  padding: 0;
  overflow-x: auto;
  list-style: none;
  border-bottom: 1px solid var(${colors.stroke.default});
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

/* The negative margin lays the active underline over the list's divider. */
export const tabLink = css`
  display: block;
  margin-bottom: -1px;
  padding: var(${spacing.md}) var(${spacing.lg});
  border-bottom: 2px solid transparent;
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  color: var(${colors.content.secondary});
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    color: var(${colors.content.default});
  }

  &[aria-current='page'] {
    border-bottom-color: var(${colors.stroke.selected});
    color: var(${colors.content.default});
    font-weight: 700;
  }
`;
